exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-2686d339] {\n  color: #0f80c1;\n}\na[data-v-2686d339]:hover {\n  text-decoration: underline;\n}\n", ""]);

// exports
